module.exports = __webpack_public_path__ + "static/media/hand.4bce545d.png";